export const updateDefault = (selector, defaultValue) => {
  if (!selector || !defaultValue) return;
  let idx = 0;
  for (let i = 1; i < selector.children.length; i++) {
    const optionValue = selector.children[i].innerHTML.trim();
    if (optionValue === defaultValue) {
      idx = i;
    }
  }
  if (idx !== 0) {
    let value = selector.removeChild(selector.children[idx]);
    selector.insertBefore(value, selector.children[1]);
    selector.value = defaultValue;
    selector.dispatchEvent(new Event('change'));
  } else {
    console.info(`O elemento "${defaultValue}" não se encontra na lista.`);
  }
};

export const updateOptions = (selector, defaultValue) => {
  if (selector.children.length > 1) {
    updateDefault(selector, defaultValue);
  } else {
    setTimeout(() => {
      updateOptions(selector, defaultValue);
    }, 1000);
  }
};
